export default __webpack_public_path__ + "media/avatars/08-941a3171.png";